import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import ReceiptIcon from '@mui/icons-material/Receipt';
import MoveToInboxIcon from '@mui/icons-material/MoveToInbox';
import StorageIcon from '@mui/icons-material/Storage';
import GradingIcon from '@mui/icons-material/Grading';
import LanguageIcon from '@mui/icons-material/Language';
import ChildFriendlyIcon from '@mui/icons-material/ChildFriendly';
import { AuditEntityType } from '@sr/dto';

import { MediaHomeTab } from 'pages/media/tabs/media-home-tab';
import { useIdParam } from 'utils/url-paramters.hook';
import { PageHeader } from 'shared/ui/details-page-header';
import { useTitleHook } from 'hooks/page-title.hook';
import { LoadingBanner } from 'shared/ui/loading-banner';
import { HorisontalListSubtitle } from 'shared/ui/horizontal-list';
import { ErrorBanner } from 'shared/ui/error-banner';
import { extractNestJsErrorMessage } from 'shared/api/rtk-query';
import { useMediaBasicData } from 'entities/media/media-basic-data';
import { NavTabInfo, NavTabs } from 'shared/ui/nav-tabs';
import { useMemo } from 'react';
import { PublishingDataForm } from 'features/publishing-data/publishing-data.form';
import { PublishingDataRelations } from 'entities/publishing-data/publishing-data.hooks';
import { ChildrenMediaList } from 'features/media/children-media/children-media-list';
import { AuditLogSection } from 'entities/audit/ui/audit-log-section';
import { MediaCommerce } from 'entities/media/media-commerce';
import { MediaCities } from 'entities/media/media-cities/media-cities';
import { LinkToMedia } from 'shared/ui/links/link-to-media';

const MediaDetailsPage = () => {
  const mediaId = useIdParam('mediaId');
  const { media, error } = useMediaBasicData(mediaId);
  useTitleHook(media && `${media.name}`);
  const tabInfos: NavTabInfo[] = useMemo(() =>
    [
      {
        path: 'home',
        label: 'Основное',
        icon: <StorageIcon />,
        component: <MediaHomeTab mediaId={mediaId} />
      },
      {
        path: 'publishing-data',
        label: 'Данные сайта',
        icon: <LanguageIcon/>,
        component:
          <PublishingDataForm
            id={media?media.publishingDataId:null} relatedType={PublishingDataRelations.media} relatedId={mediaId} media={media}
          />
      },
      {
        path: 'commerce',
        label: 'Цены',
        icon: <AccountBalanceIcon />,
        component:
          <MediaCommerce media={media} mediaId={mediaId} />
      },
      {
        path: 'cities',
        label: 'Города',
        icon: <ReceiptIcon />,
        component: <MediaCities mediaId={mediaId} />
      },
      {
        path: 'metrics',
        label: 'Метрика',
        icon: <MoveToInboxIcon />,
        component: <></>,
        disabled: true
      },
      {
        path: 'audit',
        label: 'Аудит',
        icon: <GradingIcon />,
        component: <AuditLogSection entityType={AuditEntityType.MEDIA} entityId={mediaId} />
      },
      
      {
        path: 'children-media',
        label: 'Дочерние СМИ',
        icon: <ChildFriendlyIcon />,
        component: media?.childrenMedia && media.childrenMedia.length > 0 
          ? <ChildrenMediaList childrenMedia={media.childrenMedia}/> 
          : <></>,
        hidden: !media?.childrenMedia || media.childrenMedia.length === 0
      }
    ].filter(tab => !tab.hidden) as NavTabInfo[]

  , [mediaId, media?.publishingDataId, media?.childrenMedia]);

  if (error)
    return <ErrorBanner errorMessage={extractNestJsErrorMessage(error)} />;

  if (!media)
    return <LoadingBanner />;

  return (
    <>
      <PageHeader
        title={
          <PageHeader.Text>
            {media.name}
            {media.childrenMedia.length > 0 && (
              <span style={{ color: '#666', fontSize: '0.75em', marginLeft: '4px' }}>
        (Материнское СМИ)
              </span>
            )}
            {media.parentMedia && (
              <span style={{ color: '#666', fontSize: '0.75em', marginLeft: '4px' }}>
        (СМИ является дочерним для{' '}
                <LinkToMedia media={media.parentMedia}>
                  {media.parentMedia.name}
                </LinkToMedia>
        )
              </span>
            )}
          </PageHeader.Text>
        }
        subHeader={<HorisontalListSubtitle items={[media.mediaType.name]} />}
        sx={{ mt: 1, mb: 0 }}
      />

      <NavTabs tabs={tabInfos} />
    </>
  );
};


export default MediaDetailsPage;
